// extracted by mini-css-extract-plugin
export var arrow = "_2s-6";
export var changeItem = "_2s-3";
export var changesHeader = "_2s-1";
export var changesList = "_2s-2";
export var container = "_2s-0";
export var pathLabel = "_2s-4";
export var value = "_2s-7";
export var valuesContainer = "_2s-5";